export function createUniqueId(): string {
  return Math
    .floor(Math.random() * (Number.MAX_SAFE_INTEGER - Date.now()))
    .toString();
}
